import React from 'react';
import EditarReserva from './EditarReserva'; 

import { ThemeProvider, createTheme } from '@mui/material/styles'; 

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#e71a4b',
    },
    secondary: {
      main: '#824395',
    },
    text: {
      primary: 'rgba(65,65,65,0.87)',
      secondary: 'rgba(84,84,84,0.6)',
      disabled: 'rgba(105,105,105,0.38)',
    },
  },
});
function App() {
  return ( <ThemeProvider theme={theme}>
    <div className="App">
      <EditarReserva />
    </div></ThemeProvider>
  );
}

export default App;